module.exports = __webpack_public_path__ + "static/cancel-sub-2f94d447c398f7e080fe8d57f52c76e5.svg";